<adapt-dialog [maxWidth]="500">
    <h3 adapt-dialog-title>Delete {{culturalActivityTypeMetadata.shortTitle}} activity</h3>

    <div adapt-dialog-content>
        <p>Are you sure you want to delete the following activity?</p>

        <blockquote *adaptLoading="!activityInfo">
            <b>{{activityInfo!.title ?? "Unknown event"}}</b>
            <br>
            Date: {{activityInfo!.startDate | adaptDate}}
        </blockquote>

        <p *ngIf="activity.extensions.isSurvey">You can schedule this survey at any time via the respective survey page.</p>
        <p *ngIf="activity.extensions.isPeerCatchup">You can schedule this {{culturalActivityTypeMetadata.shortTitle}} again at any time via the Peer Catch-Ups page, or the team Network Health page.</p>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveButtonPreset="deleteAndClose"
                                   [saveBlockingClick]="saveAndClose"
                                   (cancelClick)="cancel()"></adapt-standard-dialog-buttons>
</adapt-dialog>
